$(document).ready(function () {
    $('.js-body').on('click', '.js-job-item', function () {
        var id = $(this).attr('data-id');
        $.ajax({
            type: "GET",
            url: '/jobs/' + id,
            dataType: 'JSON',
            success: function (data) {
                $('.js-job-description-wrapper').show()
                $('.js-job-location').empty().append(data.location)
                $('.js-job-title').empty().append(data.title)
                $('.js-job-company-name').empty().append(data.company_name)
                $('.js-job-desc').empty().append(data.description.replace(/\n/g, "<br />"))
                $('.js-job-created-at').empty().append(data.created_at)
                $('.js-job-type').empty().append(data.type)
                output = ''
                data.skills.split(',').forEach(sill => {
                    output = output + '<span class="job-skill-tag">' + sill + '</span> '
                });
                $('.js-job-skills').empty().append(output)
            }
        });
    })

    $('.js-body').on('click', '.js-btn-apply-this-job', function () {
        alert('apply this job')
    })

    $('.js-body').on('click', '.js-apply-form', function () {
        if ($('.js-full-time').is(':checked')) {
            $('.js-full-time-salary').show()
        } else {
            $('.js-full-time-salary').hide()
        }

        if ($('.js-is-podcaster').is(':checked')) {
            $('.js-podcast-info').show()
        } else {
            $('.js-podcast-info').hide()
        }
    })

    $('.js-body').on('click', '.js-send-apply-form', function () {
        var formData = $('.js-apply-form').serialize()
        console.log(formData)
        $.ajax({
            type: "GET",
            url: '/job-apply/?' + formData,
            dataType: 'JSON',
            success: function (data) {
                console.log(data)
                if (data.ok == true) {
                    $('.modal-body').empty().append('<h2 style="color: green;">Submitted successfully</h2>')
                    $('.js-send-apply-form').hide()
                } else {
                    $('.js-error-form-apply').empty().append(data.error)
                }
            }
        });
    })


    $('.js-body').on('click', '.js-send-email-get-in-touch', function () {
        var formData = $('.js-get-in-touch-form').serialize()
        console.log(formData)
        $.ajax({
            type: "GET",
            url: '/get_in_touch/?' + formData,
            dataType: 'JSON',
            success: function (data) {
                if (data.ok == true) {
                    $('.modal-body').empty().append('<h2 style="color: green;">Submitted successfully</h2>')
                    $('.js-send-apply-form').hide()
                } else {
                    $('.js-error-form-get-in-touch').empty().append(data.error)
                }
            }
        });
    })

    $('.js-body').on('click', '.js-send-resume', function () {
        var fd = new FormData();    
        var email = $("#email").val()
        var text = $("#text").val()
        var csrf = $("input[name='csrfmiddlewaretoken']").val();
        var resume = $("#resume")[0].files[0]

        fd.append('resume', resume)
        fd.append('email', email)
        fd.append('text', text)
        fd.append('csrfmiddlewaretoken', csrf)

        $.ajax({
            url: '/send_resume/',
            data: fd,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function (data) {
                console.log("data:")
                console.log(data)
                if (data.ok == true) {
                    $('.modal-body').empty().append('<h2 style="color: green;">Your CV submitted successfully!</h2>')
                    $('.js-send-apply-form').hide()
                } else {
                    $('.js-error-form-send-resume').empty().append(data.error)
                }
            }
        });
    })

    $('.js-body').on('click', '.js-send-message', function () {
        var fd = new FormData();    
        var email = $("#email").val()
        var text = $("#text").val()
        var messageTo = $("#to").val()
        var csrf = $("input[name='csrfmiddlewaretoken']").val();

        fd.append('email', email)
        fd.append('text', text)
        fd.append('to', messageTo)
        fd.append('csrfmiddlewaretoken', csrf)

        $.ajax({
            url: '/send_message/',
            data: fd,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function (data) {
                console.log("data:")
                console.log(data)
                if (data.ok == true) {
                    $('.modal-body').empty().append('<h2 style="color: green;">Your message sent successfully!</h2>')
                    $('.js-send-message-form').hide()
                } else {
                    $('.js-error-form-send-message').empty().append(data.error)
                }
            },
            error: function() { 
            console.log("here")
                $('.js-error-form-send-message').empty().append("Internal server error, please try again later!")
            }
            
        });
    })
})
